import React                from "react";
import Store                from "Dashboard/Core/Store";

// Components
import SettingsPage         from "Components/App/Profile/SettingsPage";
import ActionLogList        from "Components/App/Log/ActionLog/ActionLogList";

// Dashboard
import Router               from "Dashboard/Components/Route/Router";
import UserRoute            from "Dashboard/Components/Route/UserRoute";
import Navigation           from "Dashboard/Components/Navigation/Navigation";
import NavigationItem       from "Dashboard/Components/Navigation/NavigationItem";



/**
 * The Profile Container
 * @returns {React.ReactElement}
 */
function ProfileContainer() {
    const { credential } = Store.useState("auth");


    // Do the Render
    return <>
        <Navigation
            message={credential.name}
            fallback="ACCOUNT_MINE"
        >
            <NavigationItem
                message="GENERAL_SETTINGS"
                url="SETTINGS"
                icon="settings"
            />
            <NavigationItem
                message="ACTIONS_LOG_NAME"
                url="LOG_ACTIONS"
                icon="action-log"
            />
        </Navigation>

        <Router type="PROFILE" withMain>
            <UserRoute
                url="SETTINGS"
                component={SettingsPage}
            />
            <UserRoute
                url="LOG_ACTIONS"
                component={ActionLogList}
            />
        </Router>
    </>;
}

export default ProfileContainer;
